import 'core-js/es/array/at'
import { scrollToElement } from '@/helpers/documentHelpers.js'
import { initCookieConsent, showCookiePreferences } from '@/utils/consentManager.js'
import { capturePreConsentData } from '@/utils/attribution.js'
import '@/styles/consentManager.scss'

window.global ||= window

window.scrollToElement = scrollToElement

// Make cookie preferences accessible globally
window.showCookiePreferences = showCookiePreferences

capturePreConsentData()

// Initialize cookie consent when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCookieConsent)
} else {
  initCookieConsent()
}
